import { message } from "antd";

const copyToClipboard = async value => {
  await navigator.clipboard.writeText(value);
  message.success(`'${value}' copied`);
};

export default copyToClipboard;
